// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-details-sidebar {
  padding: 0 5px;
}

.contact-details-avatar {
  --avatar-size: 80px;
  --presence-size: calc(var(--avatar-size) * 0.2);
  --presence-border: calc(var(--avatar-size) * 0.0375);
  display: flex;
  justify-content: center;
  margin-top: 32px;
  margin-bottom: 16px;
  position: relative;
  width: var(--avatar-size);
  height: var(--avatar-size);
  margin-left: auto;
  margin-right: auto;
}

.contact-details-avatar-img {
  width: var(--avatar-size);
  height: var(--avatar-size);
  border-radius: 50%;
  object-fit: cover;
}

.contact-details-presence-indicator {
  position: absolute;
  bottom: calc(var(--avatar-size) * 0.075);
  right: calc(var(--avatar-size) * 0.075);
  width: var(--presence-size);
  height: var(--presence-size);
  border-radius: 50%;
  border: var(--presence-border) solid white;
  background-color: #cccccc;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  z-index: 2;
}

.contact-details-name {
  font-family: Roboto, sans-serif;
  font-weight: 500;
  font-size: 21px;
  text-align: center;
  margin-bottom: 8px;
}

.contact-details-user-id {
  font-family: Roboto, sans-serif;
  font-size: 14px;
  color: rgba(155, 155, 155, 1);
  text-align: center;
  margin-bottom: 4px;
}

.contact-details-last-active {
  font-family: Roboto, sans-serif;
  font-size: 14px;
  color: rgba(155, 155, 155, 1);
  text-align: center;
  margin-bottom: 24px;
}

/* Settings list container */
.contact-details-settings-list {
  display: flex;
  flex-direction: column;
  gap: 0;
  background-color: transparent;
  border-radius: 8px;
  overflow: hidden;
  margin-top: 24px;
}

/* Row layout (similar to SettingsToggle) */
.contact-details-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background-color: white;
  gap: 8px;
  transition: background-color 0.2s ease;
  font-family: 'roboto', sans-serif;
}

.contact-details-row:hover {
  background-color: #fafafa;
}

.contact-details-row-clickable {
  cursor: pointer;
  user-select: none;
}

.contact-details-row-clickable:active {
  background-color: #f0f0f0;
}

.contact-details-row-disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background-color: #f9f9f9;
}

.contact-details-row-disabled:hover {
  background-color: #f9f9f9;
}

.contact-details-row-disabled .contact-details-row-label {
  color: #666;
  font-style: italic;
}

.contact-details-row-icon {
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.contact-details-row-icon i {
  font-size: 18px;
  color: #333;
}

.contact-details-row-icon-danger i {
  color: #f44336;
}

.contact-details-row-label {
  flex: 1;
  font-size: 14px;
  line-height: 14px;
  font-weight: normal;
}

.contact-details-row-control {
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
}

/* Dropdown (similar to PermissionRow) */
.contact-details-select {
  padding: 6px 20px 6px 6px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 13px;
  background-color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 80px;
}

.contact-details-select:hover:not(:disabled) {
  border-color: #999;
}

.contact-details-select:focus {
  outline: none;
  border-color: #666;
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.05);
}

.contact-details-select:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.6;
}

.contact-details-custom-input-container {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 4px;
  z-index: 1000;
}

.contact-details-custom-input {
  padding: 6px 12px;
  border: 1px solid #999;
  border-radius: 6px;
  font-size: 13px;
  width: 120px;
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.contact-details-custom-input:focus {
  outline: none;
  border-color: #666;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.contact-details-custom-input:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.contact-details-custom-value {
  font-size: 13px;
  color: #666;
  margin-left: 4px;
}

.contact-details-custom-value-clickable {
  cursor: pointer;
  color: #2196f3;
}

.contact-details-custom-value-clickable:hover {
  color: #1976d2;
  text-decoration: underline;
}

/* Legacy styles - keep for backward compatibility */
.contact-details-section {
  margin-bottom: 24px;
}

.contact-details-label {
  display: block;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 8px;
  color: #333;
}

.contact-details-dropdown {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  background-color: white;
  cursor: pointer;
}

.contact-details-dropdown:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.contact-details-custom-level {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.contact-details-input {
  flex: 1;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.contact-details-input:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.contact-details-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
}

.contact-details-button {
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.contact-details-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.contact-details-button-primary {
  background-color: #2196f3;
  color: white;
}

.contact-details-button-primary:hover:not(:disabled) {
  background-color: #1976d2;
}

.contact-details-button-danger {
  background-color: #f44336;
  color: white;
}

.contact-details-button-danger:hover:not(:disabled) {
  background-color: #d32f2f;
}

.contact-details-button-secondary {
  background-color: #e0e0e0;
  color: #333;
}

.contact-details-button-secondary:hover:not(:disabled) {
  background-color: #bdbdbd;
}

.contact-details-presence {
  font-size: 13px;
  color: #4caf50;
  margin-bottom: 8px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/RightSidebar/ContactDetailsSidebar.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,oDAAoD;EACpD,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,uCAAuC;EACvC,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,0CAA0C;EAC1C,yBAAyB;EACzB,wCAAwC;EACxC,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,uBAAuB;EACvB,QAAQ;EACR,sCAAsC;EACtC,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA,wCAAwC;AACxC;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,oDAAoD;AACpD;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":[".contact-details-sidebar {\n  padding: 0 5px;\n}\n\n.contact-details-avatar {\n  --avatar-size: 80px;\n  --presence-size: calc(var(--avatar-size) * 0.2);\n  --presence-border: calc(var(--avatar-size) * 0.0375);\n  display: flex;\n  justify-content: center;\n  margin-top: 32px;\n  margin-bottom: 16px;\n  position: relative;\n  width: var(--avatar-size);\n  height: var(--avatar-size);\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.contact-details-avatar-img {\n  width: var(--avatar-size);\n  height: var(--avatar-size);\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.contact-details-presence-indicator {\n  position: absolute;\n  bottom: calc(var(--avatar-size) * 0.075);\n  right: calc(var(--avatar-size) * 0.075);\n  width: var(--presence-size);\n  height: var(--presence-size);\n  border-radius: 50%;\n  border: var(--presence-border) solid white;\n  background-color: #cccccc;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n  z-index: 2;\n}\n\n.contact-details-name {\n  font-family: Roboto, sans-serif;\n  font-weight: 500;\n  font-size: 21px;\n  text-align: center;\n  margin-bottom: 8px;\n}\n\n.contact-details-user-id {\n  font-family: Roboto, sans-serif;\n  font-size: 14px;\n  color: rgba(155, 155, 155, 1);\n  text-align: center;\n  margin-bottom: 4px;\n}\n\n.contact-details-last-active {\n  font-family: Roboto, sans-serif;\n  font-size: 14px;\n  color: rgba(155, 155, 155, 1);\n  text-align: center;\n  margin-bottom: 24px;\n}\n\n/* Settings list container */\n.contact-details-settings-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  background-color: transparent;\n  border-radius: 8px;\n  overflow: hidden;\n  margin-top: 24px;\n}\n\n/* Row layout (similar to SettingsToggle) */\n.contact-details-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px;\n  background-color: white;\n  gap: 8px;\n  transition: background-color 0.2s ease;\n  font-family: 'roboto', sans-serif;\n}\n\n.contact-details-row:hover {\n  background-color: #fafafa;\n}\n\n.contact-details-row-clickable {\n  cursor: pointer;\n  user-select: none;\n}\n\n.contact-details-row-clickable:active {\n  background-color: #f0f0f0;\n}\n\n.contact-details-row-disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  background-color: #f9f9f9;\n}\n\n.contact-details-row-disabled:hover {\n  background-color: #f9f9f9;\n}\n\n.contact-details-row-disabled .contact-details-row-label {\n  color: #666;\n  font-style: italic;\n}\n\n.contact-details-row-icon {\n  width: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.contact-details-row-icon i {\n  font-size: 18px;\n  color: #333;\n}\n\n.contact-details-row-icon-danger i {\n  color: #f44336;\n}\n\n.contact-details-row-label {\n  flex: 1;\n  font-size: 14px;\n  line-height: 14px;\n  font-weight: normal;\n}\n\n.contact-details-row-control {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  position: relative;\n}\n\n/* Dropdown (similar to PermissionRow) */\n.contact-details-select {\n  padding: 6px 20px 6px 6px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 13px;\n  background-color: white;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 80px;\n}\n\n.contact-details-select:hover:not(:disabled) {\n  border-color: #999;\n}\n\n.contact-details-select:focus {\n  outline: none;\n  border-color: #666;\n  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.05);\n}\n\n.contact-details-select:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.contact-details-custom-input-container {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 4px;\n  z-index: 1000;\n}\n\n.contact-details-custom-input {\n  padding: 6px 12px;\n  border: 1px solid #999;\n  border-radius: 6px;\n  font-size: 13px;\n  width: 120px;\n  background-color: white;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n.contact-details-custom-input:focus {\n  outline: none;\n  border-color: #666;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n.contact-details-custom-input:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n\n.contact-details-custom-value {\n  font-size: 13px;\n  color: #666;\n  margin-left: 4px;\n}\n\n.contact-details-custom-value-clickable {\n  cursor: pointer;\n  color: #2196f3;\n}\n\n.contact-details-custom-value-clickable:hover {\n  color: #1976d2;\n  text-decoration: underline;\n}\n\n/* Legacy styles - keep for backward compatibility */\n.contact-details-section {\n  margin-bottom: 24px;\n}\n\n.contact-details-label {\n  display: block;\n  font-weight: 500;\n  font-size: 14px;\n  margin-bottom: 8px;\n  color: #333;\n}\n\n.contact-details-dropdown {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n  background-color: white;\n  cursor: pointer;\n}\n\n.contact-details-dropdown:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n\n.contact-details-custom-level {\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.contact-details-input {\n  flex: 1;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.contact-details-input:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n\n.contact-details-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.contact-details-button {\n  width: 100%;\n  padding: 12px;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.contact-details-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.contact-details-button-primary {\n  background-color: #2196f3;\n  color: white;\n}\n\n.contact-details-button-primary:hover:not(:disabled) {\n  background-color: #1976d2;\n}\n\n.contact-details-button-danger {\n  background-color: #f44336;\n  color: white;\n}\n\n.contact-details-button-danger:hover:not(:disabled) {\n  background-color: #d32f2f;\n}\n\n.contact-details-button-secondary {\n  background-color: #e0e0e0;\n  color: #333;\n}\n\n.contact-details-button-secondary:hover:not(:disabled) {\n  background-color: #bdbdbd;\n}\n\n.contact-details-presence {\n  font-size: 13px;\n  color: #4caf50;\n  margin-bottom: 8px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
